export default __webpack_public_path__ + "static/galaxy-audio-c73f80c7b0a46250d725359215fc6c22.mp3";